export const DIRECTOR_PROTOCOL_URL = 'qline-the-game://director/create-room';
export const DIRECTOR_STARTUP_GRACE_MS = 30_000;

export function directorLaunchTimedOut(startedAt, now = Date.now()) {
  return Number.isFinite(startedAt) && now - startedAt >= DIRECTOR_STARTUP_GRACE_MS;
}
